export default __webpack_public_path__ + "static/The Adventure_image 2@2x-9d060e0139633954aaf1eb8b0a2a9063.jpg";